/**
 * IconSelector 型定義
 */

/** 選択ステップ */
export enum SelectionStep {
  /** 初期選択（3択） */
  INITIAL = "INITIAL",
  /** プリセットアイコン選択 */
  PRESET = "PRESET",
  /** プロフィールAI生成 */
  PROFILE_AI = "PROFILE_AI",
  /** 素材選択 */
  MATERIAL = "MATERIAL",
}

/** ユーザータイプ */
export enum UserType {
  /** 子供 */
  CHILD = "CHILD",
  /** 保護者 */
  PARENT = "PARENT",
}

/** 表示モード */
export enum DisplayMode {
  /** モーダル表示 */
  MODAL = "MODAL",
  /** インライン表示 */
  INLINE = "INLINE",
}

/** プロフィール情報（AI生成時に入力した情報） */
export interface ProfileInfo {
  gender?: string | null;
  birthday?: string;
  favorite_color?: string[];
  favorite_animal?: string[];
  favorite_food?: string[];
  strength?: string[];
  interests?: string[];
  self_introduction?: string;
  /** 得意な教科 */
  best_subject?: string[];
  /** 身につけるもの */
  accessory?: string[];
  /** 髪型 */
  hairstyle?: string | null;
  /** 体型 */
  body_type?: string | null;
  /** 顔の形 */
  face_shape?: string | null;
}

/** IconSelector Props */
export interface IconSelectorProps {
  /** 現在のアイコンURL */
  currentIcon?: string;
  /** 対象ユーザーUID */
  targetUid?: string;
  /** ユーザータイプ */
  userType: UserType;
  /** 表示モード */
  mode: DisplayMode;
  /** アイコン選択コールバック（ProfileAI時はプロフィール情報も含む） */
  onSelect: (iconUrl: string, profileInfo?: ProfileInfo) => void;
  /** 閉じるコールバック（モーダルモード時） */
  onClose?: () => void;
  /** AI機能が使用可能か */
  canUseAI?: boolean;
  /** 素材選択が使用可能か（ログインユーザーのみ） */
  canUseMaterial?: boolean;
  /** プリセット選択が使用可能か（保護者向けはfalse） */
  canUsePreset?: boolean;
  /** 開いているかどうか（モーダルモード時） */
  open?: boolean;
  /** 自己紹介（既存ユーザー編集時） */
  selfIntroduction?: string;
}

/** 子供用性別（3択） */
export enum ChildGender {
  MALE = "male",
  FEMALE = "female",
  NONE = "none",
}

/** 保護者用性別（5択） */
export enum ParentGender {
  MALE = "male",
  FEMALE = "female",
  OTHER = "other",
  PREFER_NOT_TO_SAY = "prefer_not_to_say",
  NOT_SPECIFIED = "not_specified",
}

/** 選択状態 */
export interface SelectionState {
  /** 選択中のアイコンURL */
  selectedIcon: string | null;
  /** アイコンソース */
  source: IconSource | null;
  /** 選択中のファイル（アップロード時） */
  selectedFile: File | null;
}

/** アイコンソース */
export enum IconSource {
  /** プリセットアイコン */
  PRESET = "PRESET",
  /** プロフィールAI生成 */
  PROFILE_AI = "PROFILE_AI",
  /** アップロード */
  UPLOAD = "UPLOAD",
  /** 履歴 */
  HISTORY = "HISTORY",
}

/** プリセットアイコンカテゴリ */
export enum PresetIconCategory {
  ALL = "ALL",
  BOY = "BOY",
  GIRL = "GIRL",
}

/** プリセットアイコン定義 */
export interface PresetIcon {
  id: string;
  url: string;
  category: PresetIconCategory;
}
